import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment-timezone";

import { Item } from "../../../shared/GridComponents";

class SingleItem extends Component {
	renderTag = tag => {
		return (
			<div key={tag} className="react-tags__selected">
				<div className="react-tags__selected-tag">
					<span className="react-tags__selected-tag-name">{tag}</span>
				</div>
			</div>
		);
	};

	render() {
		const { item, crud, timeZone } = this.props;
		const { startsAt, endsAt, tags } = item;
		const timeZoneGuess = moment.tz.guess();
		const timeZoneToUse = timeZone ? timeZone : timeZoneGuess;

		const startTime = moment(startsAt)
			.tz(timeZoneToUse)
			.format("MMMM Do YYYY, h:mmA");
		const endTime = endsAt
			? moment(endsAt)
					.tz(timeZoneToUse)
					.format("h:mmA")
			: "";
		const timeToDisplay = endsAt ? `${startTime} - ${endTime}` : `${startTime}`;

		return (
			<Item
				crud={crud}
				{...item}
				subTitle={timeToDisplay}
				singularItemName="Session"
				content={<div className="react-tags">{tags && tags.map(tag => this.renderTag(tag))}</div>}
			/>
		);
	}
}

SingleItem.propTypes = {
	item: PropTypes.object.isRequired,
	crud: PropTypes.object.isRequired,
	timeZone: PropTypes.string,
};

export default SingleItem;
